<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <div class="com-table-top">
            <span class="title">신규등록</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-table-wrap">
                <span class="top-title">
                    <span class="title">기본정보</span>
                </span>
                <div class="com-card-input half-type">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">센터</span>
                            <div class="input-cnt">
                                <select-form
                                    :select-data="['선택', ...chainCenterType]"
                                    :select-value="['', ...chainCenterTypeValue]"
                                    :selected-value="parseInt(centerId)"
                                    class="w220"
                                    @update:set="(val) => (centerId = val)"
                                ></select-form>
                            </div>
                        </div>
                        <div class="line">
                            <div class="division">
                                <span class="tit">
                                    회원명
                                    <span class="imp">*</span>
                                    <small>(반드시 본명 입력)</small>
                                </span>
                                <div class="input-cnt">
                                    <input v-model.trim="editField.name" class="w220" maxlength="16" type="text" />
                                </div>
                            </div>
                            <div class="division">
                                <span class="tit">닉네임</span>
                                <div class="input-cnt">
                                    <input v-model.trim="editField.nickName" class="w220" maxlength="16" type="text" />
                                </div>
                            </div>
                            <p class="notice-txt">
                                ※ 이름과 연락처는 회원 APP 사용 시 센터이용권을 연동하는 정보로 사용되므로
                                <br />
                                반드시 본명을 입력해 주세요.
                                <br />
                                앱 연동 이후에는 수정이 불가합니다.
                            </p>
                        </div>
                        <div class="line">
                            <span class="tit">
                                연락처
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <input
                                        v-model="editField.phone[0]"
                                        maxlength="3"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <input
                                        v-model="editField.phone[1]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <input
                                        v-model="editField.phone[2]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <div>
                                        <btn-loading-spinner v-if="isProgressPhoneCheck"></btn-loading-spinner>
                                        <button
                                            v-else
                                            :disabled="isCheckedPhone"
                                            class="com-btn"
                                            @click="checkDuplicatePhone"
                                        >
                                            중복확인
                                        </button>
                                    </div>

                                    <span
                                        v-if="showPhoneCheckMsg === true || showPhoneCheckMsg === false"
                                        :class="{ error: true, red: !showPhoneCheckMsg, green: showPhoneCheckMsg }"
                                    >
                                        {{ showPhoneCheckMsg === true ? '사용 가능합니다.' : '중복된 번호입니다.' }}
                                    </span>
                                </div>
                            </div>
                            <div class="sub">
                                <div class="com-check">
                                    <input
                                        id="phone-check-1"
                                        v-model="editField.parentTelNoYn"
                                        name="phone-check"
                                        type="checkbox"
                                    />
                                    <label for="phone-check-1">보호자 연락처</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">현금영수증</span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <input
                                        v-model="editField.taxTelNo[0]"
                                        maxlength="3"
                                        type="text"
                                        @keypress="isNumber($event)"
                                    />
                                    <input
                                        v-model="editField.taxTelNo[1]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                    />
                                    <input
                                        v-model="editField.taxTelNo[2]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                    />
                                </div>
                            </div>
                            <div class="sub">
                                <div class="com-check">
                                    <input
                                        id="phone-check-2"
                                        v-model="equalPhoneAndTaxNo"
                                        name="phone-check-2"
                                        type="checkbox"
                                    />
                                    <label for="phone-check-2">연락처와 동일</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                성별
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-1-2"
                                        v-model="editField.sex"
                                        name="radio-1"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-1-2">여성</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-1-1"
                                        v-model="editField.sex"
                                        name="radio-1"
                                        type="radio"
                                        value="M"
                                    />
                                    <label for="radio-1-1">남성</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">생년월일</span>
                            <div class="input-cnt">
                                <single-calendar
                                    :date="editField.birthday"
                                    class="w220"
                                    @update="onChangeBirthDay"
                                ></single-calendar>
                                <input
                                    maxlength="8"
                                    placeholder="직접입력(YYYYMMDD)"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeBirthDayTyping($event)"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">회원그룹</span>
                            <div class="input-cnt">
                                <select-check-form
                                    :select-data="[...memberGroupList]"
                                    :select-value="[...memberGroupValueList]"
                                    class="w435"
                                    title="선택"
                                    @update:set="onChangeMemberGroup"
                                ></select-check-form>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">사진</span>
                            <div class="input-cnt photo-line">
                                <span class="photo">
                                    <img :src="defaultImageUrl" alt="사진" />
                                </span>
                                <div class="info-txt">
                                    <span class="txt">※ 권장 이미지 : 정사각형 사이즈, JPG, PNG 가능</span>
                                    <b-form-file
                                        id="file1"
                                        accept=".jpg, .png, .gif"
                                        plain
                                        @change="handleImage"
                                    ></b-form-file>
                                    <label class="com-btn" for="file1">파일첨부</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                출석체크번호
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <!-- 임의로 추가 -->
                                    <input
                                        v-model="editField.attendNo"
                                        class="w220"
                                        maxlength="10"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeAttendNo"
                                    />
                                    <div>
                                        <btn-loading-spinner v-if="isProgressAttendNoCheck"></btn-loading-spinner>
                                        <button
                                            v-else
                                            :disabled="isCheckedAttendNo"
                                            class="com-btn"
                                            @click="checkDuplicateAttendNo"
                                        >
                                            중복확인
                                        </button>
                                    </div>
                                    <span
                                        v-if="showAttendNoCheckMsg === true || showAttendNoCheckMsg === false"
                                        :class="{
                                            error: true,
                                            red: !showAttendNoCheckMsg,
                                            green: showAttendNoCheckMsg,
                                        }"
                                    >
                                        {{ showAttendNoCheckMsg === true ? '사용 가능합니다.' : '중복된 번호입니다.' }}
                                    </span>
                                </div>
                                <!-- 임의로 추가 -->
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">이메일</span>
                            <div class="input-cnt">
                                <div class="com-email">
                                    <input v-model="editField.email[0]" class="first" type="text" disabled />
                                    <span class="txt">@</span>
                                    <input
                                        v-model="editField.email[1]"
                                        class="last"
                                        maxlength="20"
                                        type="text"
                                        disabled
                                    />
                                    <select-form
                                        disabled
                                        :select-data="['직접 입력', ...emailTypeList]"
                                        :select-value="['', ...emailTypeValueList]"
                                        @update:set="(val) => onChangeEmailSelect(val)"
                                    ></select-form>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="line">
                            <span class="tit">비밀번호 <span class="imp">*</span></span>
                            <div class="input-cnt">
                                <input type="password" class="w220" v-model="editField.password" maxlength="15">
                            </div>
                        </div> -->
                        <div class="line">
                            <span class="tit">주소</span>
                            <div class="input-cnt">
                                <input
                                    v-model="editField.address"
                                    class="max-400 calc-100"
                                    readonly
                                    type="text"
                                    @click="postPop = true"
                                />
                                <button class="com-btn" @click="postPop = true">주소검색</button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">상세주소</span>
                            <div class="input-cnt">
                                <input v-model="editField.addressDetail" class="w400" maxlength="30" type="text" />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">마케팅 동의여부</span>
                            <div class="input-cnt">
                                <div class="com-check">
                                    <input
                                        id="check-1-1"
                                        v-model="editField.mktAgreeEmail"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label for="check-1-1">이메일</label>
                                </div>
                                <div class="com-check">
                                    <input
                                        id="check-1-2"
                                        v-model="editField.mktAgreeSms"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label for="check-1-2">SMS/MMS</label>
                                </div>
                                <div class="com-check">
                                    <input
                                        id="check-1-3"
                                        v-model="editField.mktAgreePush"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label for="check-1-3">PUSH</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                메모 ({{ lodash.get(editField, 'memo.length', 0) | numberFormatFilter }} /
                                {{ MEMO_MAX_LEN | numberFormatFilter }})
                            </span>
                            <div class="input-cnt">
                                <textarea
                                    v-model="editField.memo"
                                    class="com-textarea w400"
                                    :maxlength="MEMO_MAX_LEN"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 주소 검색 레이어 팝업 -->
            <div v-if="postPop === true" class="layer-pop square">
                <div class="view-content w600">
                    <button class="close" @click="postPop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <span class="title">주소 검색</span>
                        <daum-post-code :on-complete="handleAddress"></daum-post-code>
                    </div>
                </div>
            </div>
            <div class="bottom-btn">
                <button class="com-btn" @click="onClickCancleBtn">취소</button>
                <button class="com-btn blue" @click="createMember">등록</button>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateTelNo } from '../../../assets/js/validation';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'memberEdit',
    mixins: [MixinAllowedMenu],
    components: { BtnLoadingSpinner, LoadingSpinner },
    props: {},
    watch: {
        // 연락처와 동일 체크시
        equalPhoneAndTaxNo: function (val) {
            if (val) {
                let {
                    phone: [phoneFirst, phoneSecond, phoneThird],
                } = this.editField;
                const tempTaxTelNo = [phoneFirst, phoneSecond, phoneThird];
                this.editField.taxTelNo = tempTaxTelNo;
            }
        },
    },
    computed: {
        fullPhoneNumber() {
            const ed = this.editField;
            return `${ed.phone[0]}${ed.phone[1]}${ed.phone[2]}`;
        },
        fullEmail() {
            const ed = this.editField;
            return `${ed.email[0]}@${ed.email[1]}`;
        },
        fullTaxTelNo() {
            const ed = this.editField;
            return `${ed.taxTelNo[0]}${ed.taxTelNo[1]}${ed.taxTelNo[2]}`;
        },
        cId() {
            return this.$store.getters['auth/cId'];
        },
        centerChains() {
            // 체인 목록 [본점, 지점, 지점...] (체인점 최고권한자만 값이 있음)
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
    },
    created() {
        this.MEMO_MAX_LEN = 1000;
    },
    mounted() {
        this.init();
        this.goMainIfNotAllowed('MB', 1);
    },
    data() {
        return {
            isLoading: false,
            isProgressPhoneCheck: false, // 연락처 중복확인 진행중 Flag
            isProgressAttendNoCheck: false, // 출석체크번호 중복확인 진행중 Flag
            postPop: false, // 주소 검색 팝업
            centerId: '',
            centerInfo: {}, // 선택한 센터 정보
            centerChainList: [], // 본점 + 지점 체인점 목록
            isCheckedPhone: false, // 연락처 중복확인 여부
            showPhoneCheckMsg: '', // 연락처 중복확인 메세지 표시 여부 ( '' : 보이지 않음, true : 정상 메세지, false : 오류 메세지
            isCheckedAttendNo: false, // 출석체크번호 중복확인 여부
            showAttendNoCheckMsg: '', // 출석체크번호 중복확인 메세지
            equalPhoneAndTaxNo: false, // 연락처와 동일 체크 여부
            checkedPhoneNumber: '', // 중복확인 끝난 연락처
            checkedAttendNo: '', // 중복확인 끝난 출석체크번호
            editCenterList: [],
            editCenterValueList: [],
            editField: {
                name: '',
                nickName: '',
                attendNo: '',
                parentTelNoYn: false, // 보호자 연락처 체크 여부
                phone: ['', '', ''],
                taxTelNo: ['', '', ''],
                email: ['', ''],
                password: '',
                birthday: '',
                sex: 'W',
                imageFile: {
                    filename: '',
                    mimetype: '',
                    base64data: '',
                },
                mileage: 0,
                address: '',
                addressDetail: '',
                mktAgreeEmail: true,
                mktAgreeSms: true,
                mktAgreePush: true,
                memo: '',
                joinTermAgreeId: 0,
                centerCustomerTeams: [],
            },
            defaultImageUrl: '/img/icons/no_photo.jpg',
            emailTypeList: [...this.$emailType],
            emailTypeValueList: [...this.$emailType],

            memberGroupList: [],
            memberGroupValueList: [],

            chainCenterType: [], // 체인 센터명 배열
            chainCenterTypeValue: [], // 체인 센터 Id 배열
        };
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;
            this.centerId = parseInt(this.cId); // 로그인한 센터 id
            this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음

            await this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            await this.fetchMemberGroupList(); // 회원 그룹 조회

            if (this.centerChainList.length === 0) {
                // 체인점 최고 관리자가 아닌 일반 센터 관리자 및 직원일 경우 접속한 아이디에 해당하는 센터만 센터 목록에 보임
                this.chainCenterType.push(this.centerInfo.centerName);
                this.chainCenterTypeValue.push(this.centerInfo.id);
                this.centerId = this.centerInfo.id;
            } else if (this.centerChainList.length !== 0) {
                // 체인점 최고 권한자일 경우 체인점에 속한 모든 센터가 목록에 보임
                this.centerChainList.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.centerId);
                    this.centerId = this.centerInfo.id; // 접속한 centerId가 기본으로 선택 되게끔 함
                });
            }
            this.isLoading = false;

            // 상담관리에서 넘어온 이름, 연락처 세팅
            if (!!this.$router.currentRoute.query.custNm) {
                this.editField.name = this.$router.currentRoute.query.custNm;
            }
            if (!!this.$router.currentRoute.query.telNo) {
                this.editField.phone = [
                    this.splitPhoneNumber(this.$router.currentRoute.query.telNo)[0],
                    this.splitPhoneNumber(this.$router.currentRoute.query.telNo)[1],
                    this.splitPhoneNumber(this.$router.currentRoute.query.telNo)[2],
                ];
            }
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            return api.get(`/admin/api/center/${this.centerId}/chain`);
        },

        // 회원그룹 체크시
        onChangeMemberGroup(val) {
            // 체크한 회원그룹 id값으로 회원그룹 이름을 찾기 위함
            this.editField.centerCustomerTeams = [];
            let findIndexList = [];
            val.forEach((v) => {
                const index = this.memberGroupValueList.findIndex((groupValue) => groupValue === v);
                findIndexList.push(index);
            });
            findIndexList.forEach((f) => {
                const temp = {
                    centerCustomerTeamId: this.memberGroupValueList[f],
                    centerCustomerTeamName: this.memberGroupList[f],
                };
                this.editField.centerCustomerTeams.push(temp);
            });
        },

        // 센터회원팀 목록 조회
        async fetchMemberGroupList() {
            try {
                const { data } = await this.sendGetMemberGroupList();
                data.forEach((g) => {
                    this.memberGroupList.push(g.c_center_cust_team_nm);
                    this.memberGroupValueList.push(g.c_center_cust_team_id);
                });
            } catch (error) {
                console.log('회원그룹을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원팀 API 호출
        sendGetMemberGroupList() {
            return api.get(`/admin/api/center/${this.centerId}/customer-team`);
        },

        // 연락처 중복확인 후 다시 수정할 경우 체크
        onChangePhoneNumber() {
            const { fullPhoneNumber } = this;
            switch (fullPhoneNumber) {
                case '':
                // case this.staffInfo.phone:
                case this.checkedPhoneNumber:
                    this.isCheckedPhone = true;
                    break;
                default:
                    this.isCheckedPhone = false;
                    this.showPhoneCheckMsg = '';
                    break;
            }
        },

        // 출석체크번호 중복확인 후 다시 수정할 경우 체크
        onChangeAttendNo() {
            const { attendNo } = this.editField;
            switch (attendNo) {
                case '':
                // case this.staffInfo.phone:
                case this.checkedAttendNo:
                    this.isCheckedAttendNo = true;
                    break;
                default:
                    this.isCheckedAttendNo = false;
                    this.showAttendNoCheckMsg = '';
                    break;
            }
        },

        // 휴대폰 번호가 숫자인지 확인
        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 스웨거 검색: 센터회원 등록
        postCreateMember(memberData) {
            return api.post(`/admin/api/center/${this.centerId}/customer`, { ...memberData });
        },

        // 센터 회원 등록
        async createMember() {
            const validate = this.validateValues();

            if (!validate.result) {
                alert(validate.msg);
                return false;
            }

            let params = this.getCreateParams();
            // 기존 상담관리 정보와 등록되는 회원 정보 연결
            params.centerConsultId = this.$router.currentRoute.query.centerConsultId;

            try {
                this.isLoading = true;
                const { data } = await this.postCreateMember(params);

                alert('회원 등록 되었습니다.');

                if (confirm('바로 이용권 결제를 진행하시겠습니까?')) {
                    await this.$router.push({
                        path: `/madmin/member/account/${data.centerId}`,
                        query: { customerId: data.centerCustomerId },
                    });
                } else {
                    await this.$router.push({ name: 'memberList' });
                }
                this.isLoading = false;
            } catch (error) {
                alert('회원 등록 중 오류가 발생했습니다.');
                console.log('===> Failed Member create : ', error);
            }
        },

        // 필수값 체크
        validateValues() {
            let result = false;
            const {
                centerId,
                name,
                nickName,
                sex,
                attendNo,
                phone: [phoneFirst, phoneSecond, phoneThird],
                email: [emailFirst, emailSecond],
                taxTelNo: [taxFirst, taxSecond, taxThird],
                password,
            } = this.editField;

            let msg = '';

            // 센터
            if (centerId === '') {
                msg = '센터를 선택하세요.';
                return { result, msg };
            }

            // 회원명
            if (name.trim() === '') {
                msg = '회원명을 입력하세요.';
                return { result, msg };
            } else if (name.length === 1) {
                msg = '회원명을 다시 입력하세요.';
                return { result, msg };
            }

            // 닉네임 길이 체크
            if (nickName.length === 1) {
                msg = '닉네임을 다시 입력하세요.';
                return { result, msg };
            }

            // 성별
            if (sex.trim() === '') {
                msg = '성별을 선택하세요.';
                return { result, msg };
            }

            // 연락처
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                msg = '연락처를 입력하세요.';
                return { result, msg };
            }
            if (
                !validateTelNo(this.fullPhoneNumber) ||
                phoneFirst.length < 2 ||
                phoneSecond.length < 3 ||
                phoneThird.length != 4
            ) {
                msg = '연락처를 다시 확인하세요.';
                return { result, msg };
            }

            if (!this.isCheckedPhone) {
                msg = '연락처 중복확인을 해주세요.';
                return { result, msg };
            }

            // 현금영수증 번호
            if (this.fullTaxTelNo.length > 0) {
                if (
                    !validateTelNo(this.fullTaxTelNo) ||
                    taxFirst.length < 2 ||
                    taxSecond.length < 3 ||
                    taxThird.length != 4
                ) {
                    msg = '현금영수증 번호를 다시 확인하세요.';
                    return { result, msg };
                }
            }

            // 출석체크번호
            if (attendNo.trim() === '') {
                msg = '출석체크번호를 입력하세요.';
                return { result, msg };
            }
            if (attendNo.length < 4) {
                msg = '출석체크번호를 다시 확인하세요.';
                return { result, msg };
            }

            if (!this.isCheckedAttendNo) {
                msg = '출석체크번호 중복확인을 해주세요.';
                return { result, msg };
            }

            // 이메일
            // if( emailFirst.trim() === '' || emailSecond.trim() === ''){
            //     msg = '이메일을 입력하세요.';
            //     return { result, msg };
            // }
            // if( !validateEmail(this.fullEmail) || emailFirst.length < 1 || emailSecond.length < 6) {
            //     msg = '이메일을 다시 확인하세요.';
            //     return { result, msg };
            // }

            // 비밀번호
            // if( password.trim() === '') {
            //     msg = '비밀번호를 입력하세요.';
            //     return { result, msg };
            // }

            // if( password.length < 8 ) {
            //     msg = '비밀번호를 8자리 이상 입력하세요.';
            //     return { result, msg };
            // }
            result = true;
            return { result };
        },

        // 회원 등록 API 호출전 파라미터 가공
        getCreateParams() {
            const {
                name,
                nickName,
                attendNo,
                parentTelNoYn,
                password,
                sex,
                imageFile,
                mileage,
                address,
                addressDetail,
                mktAgreeEmail,
                mktAgreeSms,
                mktAgreePush,
                memo,
                joinTermAgreeId,
                centerCustomerTeams,
            } = this.editField;
            const phone = this.fullPhoneNumber;
            const taxTelNo = this.fullTaxTelNo;
            const email = this.fullEmail;
            const birthday = this.editField.birthday.replace(/-/g, '');

            const params = {
                name,
                nickName,
                attendNo,
                parentTelNoYn,
                password,
                birthday,
                sex,
                imageFile,
                mileage,
                address,
                addressDetail,
                mktAgreeEmail,
                mktAgreeSms,
                mktAgreePush,
                memo,
                joinTermAgreeId,
                phone,
                taxTelNo,
                email,
                centerCustomerTeams,
            };
            if (imageFile.filename === '') {
                delete params.imageFile;
            }
            return params;
        },

        // 다음 주소 API 콜백
        handleAddress(data) {
            let fullAddress = data.address;
            let extraAddress = '';
            if (data.addressType === 'R') {
                if (data.bname !== '') {
                    extraAddress += data.bname;
                }
                if (data.buildingName !== '') {
                    extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
                }
                fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
            }
            this.editField.address = fullAddress; // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
            this.postPop = false;
        },

        // 이메일 select 변경시
        onChangeEmailSelect(val) {
            const temp = [this.editField.email[0], val];
            this.editField.email = temp;
        },

        // 연락처 중복 확인
        async checkDuplicatePhone() {
            const {
                phone: [phoneFirst, phoneSecond, phoneThird],
                parentTelNoYn,
            } = this.editField;
            // 연락처 입력 확인
            if (
                !validateTelNo(this.fullPhoneNumber) ||
                phoneFirst.length < 2 ||
                phoneSecond.length < 3 ||
                phoneThird.length < 4
            ) {
                alert('연락처를 다시 확인해주세요.');
                return;
            }
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                alert('연락처를 입력하세요.');
                return false;
            }

            this.isProgressPhoneCheck = true;
            this.showPhoneCheckMsg = '';
            const { data } = await this.sendGetDuplicatePhone(this.centerId, this.fullPhoneNumber, parentTelNoYn);

            if (!data) {
                this.isCheckedPhone = true;
                this.checkedPhoneNumber = this.fullPhoneNumber;
                this.editField.attendNo = phoneThird; // 연락처 마지막 4자리를 출석체크번호로 자동 입력
                this.showPhoneCheckMsg = true;

                let duplicateAttendNo = true;
                let cnt = '0';
                while (duplicateAttendNo) {
                    // 출석체크번호가 중복이 아닐때까지 반복
                    cnt = String(parseInt(cnt) + 1);
                    duplicateAttendNo = await this.checkDuplicateAttendNo();
                    // 출석번호 체크번호가 중복이면 출석번호 끝에 자리수를 추가하고 1부터 중복이 아닐때까지 더함 ex) 9999가 중복이면 99991, 99992, 99993...
                    if (duplicateAttendNo === true && this.editField.attendNo.length === 4) {
                        this.editField.attendNo = this.editField.attendNo + '1';
                    } else if (duplicateAttendNo === true && this.editField.attendNo.length !== 4) {
                        this.editField.attendNo = String(parseInt(this.editField.attendNo) + 1);
                    } else {
                        duplicateAttendNo = false; // 중복이 아니면 루프 종료
                    }
                }
            } else {
                this.isCheckedPhone = false;
                this.checkedPhoneNumber = '';
                this.showPhoneCheckMsg = false;
            }
            this.isProgressPhoneCheck = false;
        },

        // 연락처 중복확인 API (중복이면 true)
        sendGetDuplicatePhone(centerId, phoneNumber, parentTelNoYn) {
            return api.get(`/admin/api/center/${centerId}/customer/phone/${phoneNumber}/duplicate`, {
                params: { parentTelNoYn },
            });
        },

        // 출석체크번호 중복확인 API (중복이면 true)
        sendGetDuplicateAttendNo(centerId, attendNo) {
            return api.get(`/admin/api/center/${centerId}/customer/attend-no/${attendNo}/duplicate`);
        },

        // 출석체크번호 중복 확인
        async checkDuplicateAttendNo() {
            this.showAttendNoCheckMsg = '';

            const { attendNo } = this.editField;

            // 출석체크번호 입력 확인
            if (attendNo.trim() === '') {
                alert('출석체크번호를 입력하세요.');
                return false;
            } else if (attendNo.length < 4) {
                alert('출석체크번호를 다시 확인하세요.');
                return false;
            }

            this.isProgressAttendNoCheck = true;
            const { data } = await this.sendGetDuplicateAttendNo(this.centerId, attendNo);

            if (!data) {
                this.isCheckedAttendNo = true;
                this.checkedAttendNo = attendNo;
                this.showAttendNoCheckMsg = true;
                this.isProgressAttendNoCheck = false;
                return false; // 출석번호 중복이 아니면 false를 반환 (연락처 중복확인시에 flag로 사용하기 위해)
            } else {
                this.isCheckedAttendNo = false;
                this.checkedAttendNo = '';
                this.showAttendNoCheckMsg = false;
                this.isProgressAttendNoCheck = false;
                return true; // 출석번호 중복이면 true를 반환 (연락처 중복확인시에 flag로 사용하기 위해)
            }
        },

        // Image 핸들러
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.editField.imageFile.filename = selectedImage.name;
            this.editField.imageFile.mimetype = selectedImage.type;
            this.createBase64Image(selectedImage);
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.defaultImageUrl = e.target.result;
                this.editField.imageFile.base64data = this.defaultImageUrl.split(',')[1];
            };
            reader.readAsDataURL(fileObj);
        },

        // 생년월일 변경 이벤트
        onChangeBirthDay(val) {
            this.editField.birthday = val;
        },

        // 취소 버튼 클릭시 회원 목록으로 이동
        onClickCancleBtn() {
            this.$router.push({ name: 'memberList' });
        },

        // 생년월일 직접 입력시
        onChangeBirthDayTyping(e) {
            if (e.target.value.length < 8) {
                return;
            }
            this.editField.birthday = moment(e.target.value).format('YYYY-MM-DD');
            e.target.value = '';
        },

        splitPhoneNumber(phoneNumber) {
            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 5px solid #e0e0e0;
    border-bottom: 5px solid #fe9616;
    animation: spin 1s linear infinite;
    position: relative;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
